export const handleGeneralError = (err: any, callbackFn: any) => {
    callbackFn(err?.response?.data?.error?.message);

    // if(!empty(err)){
    //     if(!empty(err.response)){
    //         if(!empty(err.response.data)){
    //             if(!empty(err.response.data.error)){
    //                 if(!empty(err.response.data.error.message)){
    //                     callbackFn(err?.response?.data?.error?.message);
    //                 }
    //             }
    //         }
    //     }
    // }
};